// for add employee

export const RESET_ADD_PERMISSIONS = "reset_add_permissions";
export const ADD_PERMISSIONS = "add_permissions";
export const ADD_PERMISSIONS_SUCCESS = "add_permissions_success";
export const ADD_PERMISSIONS_FAILURE = "add_permissions_failure";
